import React from 'react';
import LocationSetupCreator from './LocationSetupCreator';

const LocationSetupCreatorView = () => {
	return <LocationSetupCreator />;
};

export default LocationSetupCreatorView;
